import { UserFilters } from '../interfaces/interfaces';

export const userFilterDefaults: UserFilters =
{
	initialized: false,
	propertyType: 'ForSale',
	homeTypes: [],
	priceMin: 0,
	priceMax: -1,
	squareFeetMin: 0,
	squareFeetMax: -1,
	lotSizeMin: 0,
	lotSizeMax: -1,
	yearBuiltMin: 0,
	yearBuiltMax: -1,
	bedroomsMin: 0,
	bathroomsMin: 0,
	parkingSpotMin: 0,
	hasGarage: false,
	maxHoaFee: -1,
	isCapcenterListing: false,
	searchArea: undefined
};

export const formatUrl = (path: string, urlData: string | string[] | undefined): string => {
	if (!urlData)
		return '';

	if (Array.isArray(urlData)) {
		const cleanedUrlDataArray = urlData.map((individualData) => {
			if (individualData.includes(' ')) {
				const individualDataArray = individualData.split(' ').map(s => s.toLowerCase());
				return individualDataArray.join('-');
			}
			return individualData;

		});

		return `/${path}/${cleanedUrlDataArray.join('-')}`;
	}

	if (urlData.includes(' ')) {
		const urlDataArray = urlData.split(' ').map(s => s.toLowerCase());
		return `/${path}/${urlDataArray.join('-')}`;
	}

	return `/${path}/${urlData}`;
};